var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
export class TableRenderState {
    constructor() {
        this.header = new Set();
        this.row = new Map();
        this.loadingmoredata = false;
        this.selectedId = "";
        this.checkedids = new Set();
        this.selectall = false;
        this.fullfolderselected = new Set();
        makeObservable(this);
    }
    setSelectId(id) {
        this.selectedId = id;
    }
    setSelectAll(folderid, select) {
        if (select) {
            this.fullfolderselected.add(folderid);
        }
        else {
            this.fullfolderselected.delete(folderid);
        }
        this.setSelectAllCheckbox(select);
    }
    setSelectAllCheckbox(select) {
        this.selectall = select;
    }
    clearSelectedFolders() {
        this.fullfolderselected.clear();
    }
    setCheckedId(id, checked) {
        if (checked) {
            this.checkedids.add(id);
        }
        else {
            this.checkedids.delete(id);
        }
    }
    clearSelectedRows() {
        const rows = this.getRows();
        this.clearSelectedFolders();
        for (const row of rows) {
            this.setCheckedId(row.id, false);
        }
    }
    clearTable() {
        this.header.clear();
        this.row.clear();
        this.selectedId = "";
        this.checkedids.clear();
    }
    setLoadingMore(loading) {
        this.loadingmoredata = loading;
    }
    addHeaders(header) {
        header.forEach((hd) => this.header.add(hd));
    }
    clearRows() {
        this.row.clear();
    }
    clearHeaders() {
        this.header.clear();
    }
    addRows(rows) {
        rows.forEach((row) => this.row.set(row.id, row));
    }
    replaceRow(row) {
        if (this.row.has(row.id)) {
            this.row.set(row.id, row);
        }
    }
    addRow(row) {
        this.row.set(row.id, row);
    }
    removeRow(row) {
        this.row.delete(row);
    }
    getHeaders() {
        return Array.from(this.header).sort((hd, hd2) => hd.index - hd2.index);
    }
    getRows() {
        return Array.from(this.row.values())
            .sort((hd, hd2) => hd.rowindex - hd2.rowindex);
    }
}
__decorate([
    observable,
    __metadata("design:type", Set)
], TableRenderState.prototype, "header", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], TableRenderState.prototype, "row", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TableRenderState.prototype, "loadingmoredata", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], TableRenderState.prototype, "selectedId", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], TableRenderState.prototype, "checkedids", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], TableRenderState.prototype, "selectall", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], TableRenderState.prototype, "fullfolderselected", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "setSelectId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "setSelectAll", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "setSelectAllCheckbox", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "clearSelectedFolders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "setCheckedId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "clearTable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "addHeaders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "clearRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "clearHeaders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "addRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "replaceRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TableRenderState.prototype, "removeRow", null);
